import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';
import {
  portfolioQueryKeys,
  portfolioSnowflakeCredentialRevokeUrl,
} from '@/lib/portfolio/api';

export function useRevokeSnowflakeCredential(portfolioId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (credentialId: number) =>
      apiPost(
        portfolioSnowflakeCredentialRevokeUrl(portfolioId, credentialId),
        {}
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.snowflakeCredentials(portfolioId),
      });
    },
  });
}
